"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthOutDTO = void 0;
class AuthOutDTO {
    accessToken;
    refreshToken;
}
exports.AuthOutDTO = AuthOutDTO;
